import { render } from "./ComingSoon.vue?vue&type=template&id=0d3e2b10&scoped=true"
import script from "./ComingSoon.vue?vue&type=script&lang=js"
export * from "./ComingSoon.vue?vue&type=script&lang=js"

import "./ComingSoon.vue?vue&type=style&index=0&id=0d3e2b10&lang=scss&global=true"
import "./ComingSoon.vue?vue&type=style&index=1&id=0d3e2b10&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d3e2b10"],['__file',"src/scripts/common/ComingSoon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d3e2b10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d3e2b10', __exports__)) {
    api.reload('0d3e2b10', __exports__)
  }
  
  module.hot.accept("./ComingSoon.vue?vue&type=template&id=0d3e2b10&scoped=true", () => {
    api.rerender('0d3e2b10', render)
  })

}


export default __exports__